import Types from './Types';
import { combineReducers } from 'redux';

const patientsReducer = (state = [], { type, payload }) => {
  switch (type) {
    case Types.FETCH_PATIENTS_SUCCESS:
      return payload.patients;
    case Types.CLEAR_PATIENTS:
      return [];
    default:
      return state;
  }
};

const loadingReducer = (state = false, { type, payload }) => {
  switch (type) {
    case Types.FETCH_PATIENTS_START:
      return true;
    case Types.FETCH_PATIENTS_SUCCESS:
    case Types.FETCH_PATIENTS_ERROR:
      return false;
    default:
      return state;
  }
};

const errorReducer = (state = null, { type, payload }) => {
  switch (type) {
    case Types.FETCH_PATIENTS_START:
      return null;
    case Types.FETCH_PATIENTS_ERROR:
      return payload.error;
    default:
      return state;
  }
};

export default combineReducers({
  patients: patientsReducer,
  loading: loadingReducer,
  error: errorReducer,
});
